<template>
	<div class="ds-kpi-card">
		<div class="ds-kpi-card__icon-wrap">
			<i class="la ds-kpi-card__icon" :class="'la-' + icon" />
		</div>
		<div class="ds-kpi-card__body">
			<div class="ds-kpi-card__value">{{ displayValue }}</div>
			<div class="ds-kpi-card__label">{{ label }}</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "OvKpiCard",
	props: {
		icon: { type: String, default: "chart-bar" },
		value: { type: [String, Number], default: "-" },
		label: { type: String, required: true },
	},
	computed: {
		displayValue() {
			if (this.value == null || this.value === "") return "-";
			return this.value;
		},
	},
};
</script>
